<template>
    <div class="object-block-document" :class="objectBlockClasses">
        <div class="object-block__main">
            <div class="object-block__header">
                <div class="object-block__header-title-container">
                    <CompassObject object="document" :size="CompassEnums.AvatarSize.SMALL" />
                    <div>
                        <div class="object-block__header-name-container">
                            <BlockName :name="data.number || data.name" :link="linkCard" />
                            <TagStatus
                                v-if="status && data.status"
                                :id="data.status?.id ?? data.status"
                                :label="status.label"
                                size="small"
                            />
                        </div>
                        <span
                            v-if="!!data.amount"
                            class="typographies-paragraph-small-regular object-block__header-caption"
                        >
                            {{
                                $filters.numberFormatWithOptions(
                                    data.amount,
                                    { precision: numformat.precision },
                                    true,
                                )
                            }}
                        </span>
                    </div>
                </div>
                <CompassIconButton
                    v-if="variant === OBJECT_BLOCK_VARIANT.LINKED"
                    icon="close"
                    @click="$emit('unlink')"
                />
            </div>
            <BlockDescriptionListPart
                v-if="displayDescriptionList && hasDescriptionListItem"
                v-bind="$props"
                :showCompany="displayCompanyDescriptionItem"
                :showContact="displayContactDescriptionItem"
            />
        </div>
        <div v-if="$slots.company && $slots.contact" class="object-block__related-container">
            <slot v-if="variant === OBJECT_BLOCK_VARIANT.OVERVIEW" name="company" />
            <slot v-if="variant === OBJECT_BLOCK_VARIANT.OVERVIEW" name="contact" />
        </div>
    </div>
</template>

<script>
import BlockGeneric from 'vcomponents/common/object/BlockGeneric.vue';
import BlockDescriptionListPart from 'vcomponents/common/object/BlockDescriptionListPart.vue';
import TagStatus from 'vcomponents/common/TagStatus/TagStatus.vue';
import { OBJECT_BLOCK_VARIANT } from 'Dictionaries/commonComponents/ObjectBlockEnums';
import SalesDocumentsStatus from 'Config/authenticated/SalesDocumentsStatus';
import { getFullNameUser } from 'Helpers/avatarHelper.js';
import { createNamespacedHelpers } from 'vuex';
const { mapState: corpState } = createNamespacedHelpers('corp');

export default {
    components: { BlockDescriptionListPart, TagStatus },
    extends: BlockGeneric,
    props: {
        variant: {
            type: String,
            default: OBJECT_BLOCK_VARIANT.PREVIEW,
            validator(value) {
                return [
                    OBJECT_BLOCK_VARIANT.PREVIEW,
                    OBJECT_BLOCK_VARIANT.OVERVIEW,
                    OBJECT_BLOCK_VARIANT.LINKED,
                ].includes(value);
            },
        },
        showCompany: {
            type: Boolean,
            default: true,
        },
        showContact: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['unlink'],
    computed: {
        ...corpState(['numformat']),
        displayCompanyDescriptionItem() {
            return this.showCompany && !!this.data.company && !this.hasSlotCompany;
        },
        displayContactDescriptionItem() {
            return this.showContact && !!this.data.contact && !this.hasSlotContact;
        },
        hasDescriptionListItem() {
            return this.displayCompanyDescriptionItem || this.displayContactDescriptionItem;
        },
        status() {
            if (!this.data.status) {
                return null;
            }
            if (this.data.status.label && this.data.status.color) {
                return this.data.status;
            }
            const statusId = this.data.status?.id ?? this.data.status;
            const status = SalesDocumentsStatus[this.data.type][statusId];
            return { color: status?.chipColor ?? '', label: status?.shortLabel ?? '' };
        },
    },
    created() {
        if (this.data.company) {
            this.data.company.link = this.getLink({
                id: this.data.company.id,
                type: 'company',
                subtype: this.data.company.type,
            });
        }
        if (this.data.contact) {
            this.data.contact.link = this.getLink({
                id: this.data.contact.id,
                type: 'people',
                subtype: this.data.contact.type,
            });
            this.data.contact.fullName = getFullNameUser(this.data.contact, true);
        }

        this.linkCard = this.getLink({
            id: this.getObjectId(),
            type: this.data.object ? this.data.object.sub_type : this.data.type,
        });
    },
};
</script>

<style lang="scss" scoped>
.object-block-document {
    .object-block-contact,
    .object-block-company {
        margin-top: var(--spacing-3);
    }
}
</style>
